"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "João Silva",
  quote: "A KRB foi fundamental para manter minha empresa em dia com as obrigações fiscais na Irlanda. Recomendo fortemente para qualquer brasileiro empreendendo aqui.",
  position: "Empreendedor Brasileiro",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/avatar_joao.png",
  flag: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/flag_brazil.png"
}, {
  author: "Maria Oliveira",
  quote: "Profissionais extremamente confiáveis e sempre disponíveis para esclarecer minhas dúvidas fiscais. Trouxeram muita tranquilidade para o meu negócio.",
  position: "Autônoma na Irlanda",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/avatar_maria.png",
  flag: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/flag_ireland.png"
}, {
  author: "Carlos Mendes",
  quote: "O suporte na abertura da minha atividade como self-employed foi impecável. Cuidaram de toda a burocracia com o Revenue de forma rápida e segura.",
  position: "Consultor de TI",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/avatar_carlos.png",
  flag: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/flag_brazil.png"
}];
export default function OQueDizemNossosClientes() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section id="o-que-dizem-nossos-clientes" className="dark bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-[120px]" />
      </div>

      <div ref={ref} className={cn("max-w-6xl mx-auto relative z-10 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="text-center mb-16">
          <h2 className="text-sm font-bold tracking-wider text-primary uppercase mb-3">
            Depoimentos
          </h2>
          <h3 className="text-3xl font-medium text-foreground !font-sans md:text-5xl">O que dizem nossos Clientes</h3>
        </div>

        <Carousel setApi={setApi} opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-4xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                <div className="flex flex-col items-center text-center px-4 md:px-12 py-8">
                  <Quote className="size-12 md:size-16 text-primary/40 mb-8 rotate-180" />
                  
                  <p className="text-2xl md:text-4xl font-serif italic text-foreground/90 leading-relaxed mb-12">
                    "{testimonial.quote}"
                  </p>
                  
                  <div className="flex flex-col items-center gap-4">
                    <SafeHydrate><Avatar className="size-20 border-2 border-primary shadow-lg shadow-primary/20">
                      <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                      <AvatarFallback className="bg-muted text-muted-foreground text-xl font-serif">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    
                    <div>
                      <h4 className="text-lg font-semibold text-foreground">
                        {testimonial.author}
                      </h4>
                      <div className="flex items-center justify-center gap-2 mt-1">
                        <span className="text-sm text-muted-foreground">
                          {testimonial.position}
                        </span>
                        <img src={testimonial.flag} alt="Flag" className="h-3.5 w-auto rounded-sm object-cover shadow-xs" />
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-center gap-3 mt-12">
            {Array.from({
            length: count
          }).map((_, index) => <Button key={index} data-index={index} variant="ghost" size="icon" className={cn("size-3 min-h-0 min-w-0 p-0 rounded-full transition-all duration-300", current === index ? "bg-primary w-8" : "bg-primary/20 hover:bg-primary/50")} onClick={() => api?.scrollTo(index)} aria-label={`Ir para o depoimento ${index + 1}`} />)}
          </div>
        </Carousel>
      </div>
    </section>;
}